// export const CGM_CODE_SET = {
//   "110": "뉴스",
//   "120": "뉴스",
//   "130": "뉴스",
//   "140": "뉴스",
//   "160": "뉴스",
//   "210": "블로그",
//   "220": "Community",
//   "250": "Community",
//   "230": "카페",
//   "260": "Q&A",
//   "320": "뉴스 댓글",
//   "340": "후기",
//   "270": "유튜브",
//   "240": "SNS"
// }
export const CGM_CODE_SET = {
  "210": "블로그",
  "220": "게시판",
  "230": "카페",
  "240": "SNS",
  "250": "전문사이트",
  "260": "지식검색",
  "270": "동영상",
  "110": "포털뉴스",
  "120": "종합일간지",
  "130": "인터넷언론",
  "140": "방송사 뉴스",
  "150": "매거진",
  "160": "경제신문",
  "310": "블로그 댓글",
  "320": "미디어 댓글",
  "330": "블로그트랙백",
  "340": "상품평",
  "350": "카페 댓글"
}

export const Channel_CODE_SET = {
  "social": "소셜 미디어",
  "blog0": "블로그",
  "blog1": "네이버 블로그",
  "blog2": "다음 블로그",
  "blog3": "티스토리",
  "club0": "클럽",
  "club1": "네이버 카페",
  "club2": "다음 카페",
  "board0": "게시판",
  "prof0": "전문사이트",
  "kin0": "지식검색",
  "sns0": "sns",
  "twit1": "트위터",
  "facebook1": "페이스북",
  "insta1": "인스타그램",
  "kakao1": "카카오스토리",
  "news": "뉴스미디어",
  "pnews0": "포털뉴스",
  "tnews0": "종합일간지",
  "inews0": "인터넷 언론",
  "bnews0": "방송사",
  "enews0": "경제전문지",
  "shop": "상품평",
  "ashop0": "옥션",
  "gshop0": "지마켓",
  "eshop0": "11번가",
  "cshop0": "쿠팡",
  "wshop0": "위메프",
  "tshop0": "티몬",
  "video0": "동영상",
  "youtube1": "유튜브",
  "renews": "포털뉴스 댓글",
  "custom0": "소셜-인스타그램제외",
  "custom10": "멀츠코리아-강남언니",
  "custom20": "네이버밴드",
}

export const Section_CODE_SET = {
  "210": "블로그",
  "1000": "네이버 블로그",
  "1001": "다음 블로그",
  "1005": "티스토리",
  "230": "클럽",
  "2000": "네이버 카페",
  "2001": "다음 카페",
  "220": "게시판",
  "250": "전문사이트",
  "260": "지식검색",
  "240": "SNS",
  "5004": "트위터",
  "5005": "페이스북",
  "5010": "인스타그램",
  "5009": "카카오스토리",
  "110": "포털뉴스",
  "120": "종합일간지",
  "130": "인터넷 언론",
  "140": "방송사",
  "160": "경제전문지",
  "340": "상품평",
  "10001": "옥션",
  "10002": "지마켓",
  "10003": "11번가",
  "10005": "쿠팡",
  "10004": "위메프",
  "10006": "티몬",
  "270": "동영상",
  "4269": "유튜브",
  "320": "포털뉴스 댓글"
}

export const CHANNEL_ARRAY_SET = [
  {
    id: "social",
    name: "소셜 미디어",
    checked: false,
    subCh: [
      {
        id: "blog0",
        name: "블로그",
        checked: false
      },
      {
        id: "blog1",
        name: "네이버 블로그",
        checked: false
      },
      {
        id: "blog2",
        name: "다음 블로그",
        checked: false
      },
      {
        id: "blog3",
        name: "티스토리",
        checked: false
      },
      {
        id: "club0",
        name: "클럽",
        checked: false
      },
      {
        id: "club1",
        name: "네이버 카페",
        checked: false
      },
      {
        id: "club2",
        name: "다음 카페",
        checked: false
      },
      {
        id: "board0",
        name: "게시판",
        checked: false
      },
      {
        id: "prof0",
        name: "전문사이트",
        checked: false
      },
      {
        id: "kin0",
        name: "지식검색",
        checked: false
      },
      {
        id: "sns0",
        name: "SNS",
        checked: false
      },
      {
        id: "twit1",
        name: "트위터",
        checked: false
      },
      // {
      //   id: "facebook1",
      //   name: "페이스북",
      //   checked: false
      // },
      {
        id: "insta1",
        name: "인스타그램",
        checked: false
      },
      {
        id: "kakao1",
        name: "카카오스토리",
        checked: false
      },
      // {
      //   id: "youtube",
      //   name: "유튜브",
      //   checked: false,
      // },
      {
        id: "video0",
        name: "동영상",
        checked: false
      },
      {
        id: "youtube1",
        name: "유튜브",
        checked: false
      }
    ]
  },
  {
    id: "news",
    name: "뉴스미디어",
    checked: false,
    subCh: [
      {
        id: "pnews0",
        name: "포털뉴스",
        checked: false
      },
      {
        id: "tnews0",
        name: "종합일간지",
        checked: false
      },
      {
        id: "inews0",
        name: "인터넷 언론",
        checked: false
      },
      {
        id: "bnews0",
        name: "방송사",
        checked: false
      },
      {
        id: "enews0",
        name: "경제전문지",
        checked: false
      },
    ]
  },
  {
    id: "shop",
    name: "상품평",
    checked: false,
    subCh: [
      {
        id: "ashop0",
        name: "옥션",
        checked: false
      },
      {
        id: "gshop0",
        name: "지마켓",
        checked: false
      },
      {
        id: "eshop0",
        name: "11번가",
        checked: false
      },
      {
        id: "cshop0",
        name: "쿠팡",
        checked: false
      },
      {
        id: "wshop0",
        name: "위메프",
        checked: false
      },
      {
        id: "tshop0",
        name: "티몬",
        checked: false
      },
    ]
  },
  {
    id: "renews",
    name: "포털뉴스 댓글",
    checked: false,
    subCh: []
  },
  // {
  //   id: "youtube",
  //   name: "유튜브",
  //   checked: false,
  //   subCh: []
  // },
];

export const CHANNEL_ARRAY_ADMIN_SET = [
  {
    id: "social",
    name: "소셜 미디어",
    checked: false,
    subCh: [
      {
        id: "blog0",
        name: "블로그",
        checked: false
      },
      {
        id: "blog1",
        name: "네이버 블로그",
        checked: false
      },
      {
        id: "blog2",
        name: "다음 블로그",
        checked: false
      },
      {
        id: "blog3",
        name: "티스토리",
        checked: false
      },
      {
        id: "club0",
        name: "클럽",
        checked: false
      },
      {
        id: "club1",
        name: "네이버 카페",
        checked: false
      },
      {
        id: "club2",
        name: "다음 카페",
        checked: false
      },
      {
        id: "board0",
        name: "게시판",
        checked: false
      },
      {
        id: "prof0",
        name: "전문사이트",
        checked: false
      },
      {
        id: "kin0",
        name: "지식검색",
        checked: false
      },
      {
        id: "sns0",
        name: "SNS",
        checked: false
      },
      {
        id: "twit1",
        name: "트위터",
        checked: false
      },
      // {
      //   id: "facebook1",
      //   name: "페이스북",
      //   checked: false
      // },
      {
        id: "insta1",
        name: "인스타그램",
        checked: false
      },
      {
        id: "kakao1",
        name: "카카오스토리",
        checked: false
      },
      // {
      //   id: "youtube",
      //   name: "유튜브",
      //   checked: false,
      // },
      {
        id: "video0",
        name: "동영상",
        checked: false
      },
      {
        id: "youtube1",
        name: "유튜브",
        checked: false
      },
      {
        id: "custom0",
        name: "소셜-인스타그램제외",
        checked: false
      },
      {
        id: "custom10",
        name: "멀츠코리아-강남언니",
        checked: false
      },
      {
        id: "custom20",
        name: "네이버밴드",
        checked: false
      }
    ]
  },
  {
    id: "news",
    name: "뉴스미디어",
    checked: false,
    subCh: [
      {
        id: "pnews0",
        name: "포털뉴스",
        checked: false
      },
      {
        id: "tnews0",
        name: "종합일간지",
        checked: false
      },
      {
        id: "inews0",
        name: "인터넷 언론",
        checked: false
      },
      {
        id: "bnews0",
        name: "방송사",
        checked: false
      },
      {
        id: "enews0",
        name: "경제전문지",
        checked: false
      },
    ]
  },
  {
    id: "shop",
    name: "상품평",
    checked: false,
    subCh: [
      {
        id: "ashop0",
        name: "옥션",
        checked: false
      },
      {
        id: "gshop0",
        name: "지마켓",
        checked: false
      },
      {
        id: "eshop0",
        name: "11번가",
        checked: false
      },
      {
        id: "cshop0",
        name: "쿠팡",
        checked: false
      },
      {
        id: "wshop0",
        name: "위메프",
        checked: false
      },
      {
        id: "tshop0",
        name: "티몬",
        checked: false
      },
    ]
  },
  {
    id: "renews",
    name: "포털뉴스 댓글",
    checked: false,
    subCh: []
  },
  // {
  //   id: "youtube",
  //   name: "유튜브",
  //   checked: false,
  //   subCh: []
  // },
];